import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useState } from "react";
import { menuItemsStyles } from "../styles";
import { MenuItemsProps } from "../types";
import { styles } from "./styles";

export const MenuItems: React.FC<MenuItemsProps> = ({
  expand,
  handleOpen,
  handleOpenVersionModal,
  loaded,
  downloadSong,
  track,
  id,
  setIsMasterModalOpen,
  isMasterModalOpen,
  openDeleteConfirmModal,
  trackUrl,
  handleOpenTrackFileModal,
  userVerified,
  allowDownload,
  setSelectedTrackForShare,
  setIsShareDetailsModalOpen,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const isSharedContentPage = window.location.pathname.includes("/share/");

  const handleAnchorEl = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box>
        <Button
          // id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClickCapture={handleAnchorEl}
          style={styles.moreHorizontalIconButton}
        >
          <MoreHorizIcon id="small-screen-track-menu" />
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {!isSharedContentPage && (
            <MenuItem
              style={menuItemsStyles.menuItem}
              onClick={() => {
                console.log(handleOpenVersionModal);
                if (handleOpenVersionModal) {
                  handleOpenVersionModal(id!);
                }
              }}
            >
              <Button sx={menuItemsStyles.menuButtons}>Add Version</Button>
            </MenuItem>
          )}
          {!isSharedContentPage && (
            <MenuItem
              style={menuItemsStyles.menuItem}
              onClick={() => {
                if (handleOpenTrackFileModal) {
                  handleOpenTrackFileModal(id!);
                }
              }}
            >
              <Button sx={menuItemsStyles.menuButtons}>Add File</Button>
            </MenuItem>
          )}
          {(!isSharedContentPage || (isSharedContentPage && allowDownload)) && (
            <MenuItem style={menuItemsStyles.menuItem} onClick={downloadSong}>
              <Button sx={menuItemsStyles.menuButtons}>Download</Button>
            </MenuItem>
          )}
          {!isSharedContentPage && (
            <MenuItem
              style={menuItemsStyles.menuItem}
              onClick={() => handleOpen(id!)}
            >
              <Button sx={menuItemsStyles.menuButtons}>Edit</Button>
            </MenuItem>
          )}
          {!isSharedContentPage && (
            <MenuItem
              style={menuItemsStyles.menuItem}
              onClick={async () => {
                if (track?.getId()) {
                  setSelectedTrackForShare(track);
                  setIsShareDetailsModalOpen(true);
                }
              }}
            >
              <Button sx={menuItemsStyles.menuButtons}>Share</Button>
            </MenuItem>
          )}
          {!isSharedContentPage && (
            <MenuItem
              style={menuItemsStyles.menuItem}
              onClick={() => setIsMasterModalOpen(!isMasterModalOpen)}
            >
              <Button sx={menuItemsStyles.menuButtons}>Master</Button>
            </MenuItem>
          )}
          {/* <MenuItem
            style={menuItemsStyles.menuItem}
            onClick={() => handleCreateGroupChat}
          >
            <Button>Track Chat</Button>
          </MenuItem>
          <MenuItem
            style={menuItemsStyles.menuItem}
            onClick={() => {
              handleOpenCollabsModal(id!);
            }}
          >
            <Button>Add Collaborators</Button>
          </MenuItem> */}
          {userVerified && !isSharedContentPage && (
            <MenuItem
              style={menuItemsStyles.menuItem}
              onClick={() =>
                navigate(`/mint`, {
                  state: {
                    trackArtist: track?.getArtist(),
                    trackUrl: trackUrl,
                    trackTitle: track?.getTitle(),
                    trackBpm: track?.getBpm(),
                    trackKeyNote: track?.getKey()?.getNote(),
                    trackKey: track?.getKey()?.getKey(),
                    trackKeyScale: track?.getKey()?.getScale(),
                    trackGenre: track?.getSongMetadata()?.getGenre(),
                    trackDescription: track?.getDescription(),
                    trackImageUrl: track?.getImageUrl(),
                    trackContributors: track
                      ?.getCollaboratorsList()
                      .map((collaborators: any) => collaborators.getUsername()),
                  },
                })
              }
            >
              <Button sx={menuItemsStyles.menuButtons}>Mint</Button>
            </MenuItem>
          )}
          {/* <MenuItem
            style={menuItemsStyles.menuItem}
            onClick={() => openDeleteConfirmModal!(id!)}
          >
            <Button sx={menuItemsStyles.menuButtons}>Delete</Button>
          </MenuItem> */}
          {!isSharedContentPage && (
            <MenuItem style={menuItemsStyles.menuItem}>
              {expand ? (
                <Button
                  sx={menuItemsStyles.menuButtons}
                  onClick={() => navigate(-1)}
                >
                  Track page
                </Button>
              ) : (
                <Button
                  sx={menuItemsStyles.menuButtons}
                  onClick={() =>
                    navigate(`/track/${id}`, {
                      state: { id: id },
                    })
                  }
                >
                  Track Details
                </Button>
              )}
            </MenuItem>
          )}
        </Menu>
      </Box>
    </>
  );
};
